/**
 * @description 颜色常量 - [r, g, b]
 * @created 2024/04/27 10:20:15
 */

// 主色调
export const COLOR_PRIMARY = [64, 158, 255]

// 成功色
export const COLOR_SUCCESS = [103, 194, 58]

// 警告色
export const COLOR_WARNING = [230, 162, 60]

// 危险色
export const COLOR_DANGER = [245, 108, 108]

// 信息色
export const COLOR_INFO = [144, 147, 153]
